import React from 'react';

interface IconProps {
  fill: string;
  stroke: string;
}

const DeliveryBoardNavigationIcon: React.FC<IconProps> = () => {
  const isDeliveryBoard = location.pathname.split('/')[1] === 'delivery-board';
  const iconColor = isDeliveryBoard ? '#012231' : 'white';
  return (
    <svg width={27} height={20} stroke={iconColor} viewBox="0 0 27 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66406 17.5234L2.67206 17.986C3.19195 18.2246 3.76222 18.3562 4.34318 18.3719C4.92414 18.3875 5.50184 18.2868 6.03606 18.0766L7.42273 17.5307C7.92054 17.3349 8.45648 17.234 8.99806 17.234C9.53964 17.234 10.0756 17.3349 10.5734 17.5307L11.9601 18.0766C12.4943 18.2868 13.072 18.3875 13.6529 18.3719C14.2339 18.3562 14.8042 18.2246 15.3241 17.986L15.8747 17.7327C16.4303 17.4776 17.0429 17.3448 17.6641 17.3448C18.2852 17.3448 18.8978 17.4776 19.4534 17.7327L20.1827 18.0668C21.1314 18.5023 22.2297 18.5741 23.2361 18.2663L25.6641 17.5234M4.33073 14.4635L2.9974 8.9557H8.33073M8.33073 8.9557V5.28384H14.7027L15.6641 8.9557M8.33073 8.9557H15.6641M21.6641 14.4635L24.9974 8.9557H14.0041H15.6641M12.3307 12.6276H12.4641M10.9974 2.22395L10.7307 1.97916C10.405 1.68054 10.0006 1.46442 9.55691 1.35181C9.1132 1.23921 8.6453 1.23396 8.19873 1.33659L7.75073 1.4394C7.2585 1.55239 6.74138 1.53413 6.26006 1.38677L4.9974 1"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeliveryBoardNavigationIcon;
